// extracted by mini-css-extract-plugin
module.exports = {"xs":"0rem","sm":"20rem","md":"37.5rem","lg":"60rem","xl":"71.25rem","contentWrapper":"FAQModal-module__contentWrapper___CGUGR","title":"FAQModal-module__title___bnM3u"};